var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('button',{class:{ open: _vm.show },attrs:{"aria-expanded":_vm.show ? 'true' : 'false'},on:{"click":function($event){return _vm.toggleShow()}}},[_c('h3',[_vm._t("question")],2),_c('span',{staticClass:"plus"})]),_vm._v(" "),_c('div',{ref:"answer",staticClass:"answer"},[_vm._t("answer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }